// 支出項目ごとの目標限度額・当月支出合計（/api/bop030rs03001/status のレスポンス）。
// 項目管理画面（BOP030W010）と月次集計画面（BOP020W030）で共用する。
export interface ExpenseStatusEntry {
  type: string;
  categoryLarge: string;
  categorySmall: string;
  targetAmount: number | null;
  // 1の場合、収支登録画面に目標限度額に対する当月支出の割合を表示する
  displayFlg: 0 | 1;
  currentMonthAmount: number;
}

// 収支登録画面に割合を表示できる項目の上限数（バックエンドのbop030rs03001Serviceと合わせる）
export const MAX_DISPLAY_COUNT = 3;

export const buildExpenseStatusKey = (type: string, categoryLarge: string, categorySmall: string): string =>
  `${type}|${categoryLarge}|${categorySmall}`;
